import cx from "classnames";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { getCurrentUser } from "src/store/actions/user";
import { useStoreActions } from "src/store/hooks";
import Header from "./Header";
import Sidebar from "./Sidebar";
import classes from "./styles.module.scss";

interface Props {
  children: React.ReactNode;
}

const PrivateLayout: React.FC<Props> = ({ children }) => {
  const [showSidebar, setShowSidebar] = useState(false);
  const actions = useStoreActions({ getCurrentUser });
  const location = useLocation();
  useEffect(() => {
    actions.getCurrentUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleScroll = () => {
    const scrollableDiv = document.getElementById("scroll");
    const scrollValue = scrollableDiv?.getBoundingClientRect() || "";
    const scrollView = document.getElementById("scrollView");

    if (scrollView) {
      if (location.pathname === "/plans" && scrollValue) {
        scrollView.style.background = `linear-gradient(#465365 ${scrollValue?.top}px, #F0F3F6 ${scrollValue?.top}px) no-repeat`;
      } else {
        scrollView.style.background = `linear-gradient(#465365 160px, #F0F3F6 160px) no-repeat`;
      }
    }
  };

  const handleSidebarToggle = () => setShowSidebar(!showSidebar);
  return (
    <div className={classes.container}>
      <Sidebar
        showSidebar={showSidebar}
        handleSidebarToggle={handleSidebarToggle}
      />
      <div
        className={cx(classes.mainContainer, {
          [classes.hideContainer]: showSidebar,
        })}
      >
        <Header handleSidebarToggle={handleSidebarToggle} />
        <div
          style={{
            background:
              "linear-gradient(#465365 160px, #F0F3F6 160px) no-repeat",
          }}
          className={classes.content}
          onScroll={handleScroll}
          id="scrollView"
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default PrivateLayout;
